import React, { useEffect, useState } from "react";
import { apiAxios } from "../../../../utils/apiAxios";
import { toast } from "react-toastify";import "bootstrap-icons/font/bootstrap-icons.css";


interface Person {
  name: string;
  rating: number;
}

interface Tier {
  tier: string;
  icon: string;
  theme: "gold" | "silver" | "bronze";
  designer: Person[];
  milling: Person[];
   delivery: Person[];
}



function initials(name: string) {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

function average(people: Person[]) {
  if (!people.length) return 0;
  return people.reduce((sum, p) => sum + p.rating, 0) / people.length;
}

function PersonRow({ person, rank }: { person: Person; rank: number }) {
  return (
    <li className={`ra-item ${rank === 1 ? "ra-item-top" : ""}`}>
      <span className="ra-rank">{rank}</span>
      <span className="ra-avatar">{initials(person.name)}</span>
      <span className="ra-name">{person.name}</span>
      <span className="ra-rating">
        <i className="bi bi-star-fill" /> {person.rating.toFixed(1)}
      </span>
    </li>
  );
}

function RankedList({ people }: { people: Person[] }) {
  const sorted = [...people].sort((a, b) => b.rating - a.rating);

  return (
    <ul className="ra-list">
      {sorted.map((p, i) => (
        <PersonRow key={p.name} person={p} rank={i + 1} />
      ))}
    </ul>
  );
}

function TierCard({ tier }: { tier: Tier }) {
  // const overall = average([...tier.designer, ...tier.milling]);
const overall = average([
  ...tier.designer,
  ...tier.milling,
  ...tier.delivery,
]);
  return (
    <div className="col-lg-4 col-md-6">
      <div className={`ra-card ra-theme-${tier.theme}`}>
        <div className="ra-card-header">
          <span className="ra-header-badge">
            <i className={`bi ${tier.icon}`} />
          </span>
          <div className="ra-header-text">
            <h5 className="ra-header-title">{tier.tier}</h5>
            <span className="ra-header-sub">
             {tier.designer.length +
 tier.milling.length +
 tier.delivery.length} providers
            </span>
          </div>
          <span className="ra-header-score">
            <i className="bi bi-star-fill" /> {overall.toFixed(1)}
          </span>
        </div>
<div className="ra-card-body">

  {/* Designer */}
  <div className="ra-section">
    <div className="ra-section-title">
      <i className="bi bi-person-badge" /> Designer
      <span className="ra-count">{tier.designer.length}</span>
    </div>
    <RankedList people={tier.designer} />
  </div>

  <div className="ra-divider" />

 


  {/* Milling */}
  <div className="ra-section">
    <div className="ra-section-title">
      <i className="bi bi-gear-wide-connected" /> Milling
      <span className="ra-count">{tier.milling.length}</span>
    </div>
    <RankedList people={tier.milling} />
  </div>
  <div className="ra-divider" />

   {/* Delivery */}
  <div className="ra-section">
    <div className="ra-section-title">
      <i className="bi bi-truck" /> Delivery Partner
      <span className="ra-count">{tier.delivery.length}</span>
    </div>
    <RankedList people={tier.delivery} />
  </div>

</div>
      </div>
    </div>
  );
}
interface TierRatingDto {
  role: string;
  assignedToID: number;
  name: string;
  averageRating: number;
  tier: string;
}
function RatingAnalytics() {

  const [tierData, setTierData] = useState<Tier[]>([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
  getTierRatings();
}, []);

const getTierRatings = async () => {
  try {
    setLoading(true);

    const res = await apiAxios.get("/Rating/TierRatings");

    console.log("API RESPONSE", res.data);

    if (res.data.isSuccess) {
     // console.log("TIER DATA", res.data.singleData);
      buildTierData(res.data.singleData);
    }
  } catch (error) {
    console.log(error);
    toast.error("Unable to fetch ratings");
  } finally {
    setLoading(false);
  }
};

const buildTierData = (data: TierRatingDto[]) => {

  const tiers: Tier[] = [
    {
      tier: "Golden Tier",
      icon: "bi-trophy-fill",
      theme: "gold",

      designer: data
        .filter(
          x =>
            x.tier === "Golden" &&
            x.role === "DESIGNER"
        )
        .map(x => ({
          name: x.name,
          rating: x.averageRating,
        })),

      milling: data
        .filter(
          x =>
            x.tier === "Golden" &&
            x.role === "MILLING HUB"
        )
        .map(x => ({
          name: x.name,
          rating: x.averageRating,
        })),
  
      delivery: data
    .filter(
      x =>
        x.tier === "Golden" &&
        x.role === "DELIVERY"
    )
    .map(x => ({
      name: x.name,
      rating: x.averageRating,
    })),
  },
    {
      tier: "Silver Tier",
      icon: "bi-award-fill",
      theme: "silver",

      designer: data
        .filter(
          x =>
            x.tier === "Silver" &&
            x.role === "DESIGNER"
        )
        .map(x => ({
          name: x.name,
          rating: x.averageRating,
        })),

      milling: data
        .filter(
          x =>
            x.tier === "Silver" &&
            x.role === "MILLING HUB"
        )
        .map(x => ({
          name: x.name,
          rating: x.averageRating,
        })),
        delivery: data
  .filter(
    x =>
      x.tier === "Silver" &&
      x.role === "DELIVERY"
  )
  .map(x => ({
    name: x.name,
    rating: x.averageRating,
  })),
    },

    {
      tier: "Bronze Tier",
      icon: "bi-shield-fill",
      theme: "bronze",

      designer: data
        .filter(
          x =>
            x.tier === "Bronze" &&
            x.role === "DESIGNER"
        )
        .map(x => ({
          name: x.name,
          rating: x.averageRating,
        })),

      milling: data
        .filter(
          x =>
            x.tier === "Bronze" &&
            x.role === "MILLING HUB"
        )
        .map(x => ({
          name: x.name,
          rating: x.averageRating,
        })),
        delivery: data
  .filter(
    x =>
      x.tier === "Bronze" &&
      x.role === "DELIVERY"
  )
  .map(x => ({
    name: x.name,
    rating: x.averageRating,
  })),
    },
  ];

  setTierData(tiers);
};
if (loading) {
  return <div className="text-center mt-5">Loading...</div>;
}
  return (
    <div className="container-fluid mt-4">
      <div className="ra-page-header">
        <div>
          <h4 className="mb-2">Performance Tiers</h4>
          <p className="text-muted mb-0">
            Top rated designers and milling hubs, ranked by tier
          </p>
        </div>
      </div>

      <div className="row g-4">
        {tierData.map((tier) => (
          <TierCard key={tier.tier} tier={tier} />
        ))}
      </div>
    </div>
  );
}

export default RatingAnalytics;
